@use "../../sass/global/global" as *;

$ux-iws-nb-filter-mobile-breakpoint: 850px;

ux-iws-nb-filter {
    display: block;
    position: relative;
    z-index: 100;

    .ux-iws-nb-filter__container {
        background-color: #fff;
        padding-top: 10px;
        padding-bottom: 10px;
        z-index: 100;

        &::after {
            content: "";
            display: block;
            position: absolute;
            bottom: -20px;
            left: 0;
            width: 100%;
            height: 20px;
            background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0.1),
                11%,
                transparent
            );
        }
    }

    form {
        display: flex;
        flex-wrap: wrap;
        align-content: stretch;
        padding-left: 30px;
        padding-right: 20px;
        margin-bottom: 0;
    }

    ux-form-group {
        display: flex !important;
        flex-grow: 1;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .ux-form-group__fieldset {
        flex-grow: 1;
        margin: 0;
    }

    .ux-form-group__wrapper {
        flex-direction: row !important;
    }

    .ux-iws-nb-filter__dropdown {
        display: inline-block;
        flex-grow: 1;
        width: 200px;

        + .ux-iws-nb-filter__dropdown {
            margin-left: 10px;
        }
    }

    .ux-dropdown {
        display: inline-block !important;
        margin-bottom: 0 !important;
        width: 100%;
    }

    .ux-dropdown__label > span {
        margin-right: 10px;
        white-space: nowrap;
    }

    ux-input-label .ux-label {
        font-weight: 300;
        color: $color-black-2;
    }

    .ux-dropdown__counter {
        margin-left: 5px;
    }

    @media (max-width: $ux-iws-nb-filter-mobile-breakpoint) {
        .ux-iws-nb-filter__dropdown + .ux-iws-nb-filter__dropdown {
            margin-left: 5px;
        }

        ux-form-group + ux-form-group {
            padding-left: 20px;
        }

        .ux-iws-nb-filter__scroll-button {
            display: inline-block;
            position: absolute;
            top: 0;
            z-index: 1;
            height: 85px;
            width: 30px;
            border: 0;
            padding: 0;
            cursor: pointer;
        }

        .ux-iws-nb-filter__scroll-button.is-deactivated ux-icon {
            opacity: 0.3;
        }

        .ux-iws-nb-filter__scroll-button.is-deactivated {
            pointer-events: none;
            cursor: default;
        }

        .ux-iws-nb-filter__scroll-button--right {
            background: linear-gradient(
                to right,
                var(--ux-tabs-container-arrow-bg-color-transparent) 0,
                var(--ux-tabs-container-arrow-bg-color) 18%
            );
            justify-content: flex-end;
            right: 0;
        }

        .ux-iws-nb-filter__scroll-button--right.is-overlapping {
            background: linear-gradient(
                to right,
                var(--ux-tabs-container-arrow-bg-color-transparent) 0,
                var(--ux-tabs-container-arrow-bg-color) 35%
            );
        }

        .ux-iws-nb-filter__scroll-button--left {
            background: linear-gradient(
                to left,
                var(--ux-tabs-container-arrow-bg-color-transparent) 0,
                var(--ux-tabs-container-arrow-bg-color) 18%
            );
            justify-content: flex-start;
            left: 0;
        }

        .ux-iws-nb-filter__scroll-button--left.is-overlapping {
            background: linear-gradient(
                to left,
                var(--ux-tabs-container-arrow-bg-color-transparent) 0,
                var(--ux-tabs-container-arrow-bg-color) 35%
            );
        }

        .ux-iws-nb-filter__scroll-button--left::before {
            background: linear-gradient(
                to left,
                var(--ux-tabs-container-arrow-bg-color-transparent) 0,
                var(--ux-tabs-container-arrow-bg-color) 80%,
                var(--ux-tabs-container-arrow-bg-color) 100%
            );
            left: 20px;
        }

        .ux-iws-nb-filter__scroll-button--right::before {
            background: linear-gradient(
                to right,
                var(--ux-tabs-container-arrow-bg-color-transparent) 0,
                var(--ux-tabs-container-arrow-bg-color) 80%,
                var(--ux-tabs-container-arrow-bg-color) 100%
            );
            right: 20px;
        }

        .ux-iws-nb-filter__scroll-button.is-overlapping::before {
            width: 34px;
        }

        .ux-iws-nb-filter__scroll-button.is-hidden {
            display: none;
        }

        .ux-iws-nb-filter__scroll-button::before {
            content: "";
            height: 100%;
            pointer-events: none;
            position: absolute;
            transition: opacity 0.5s ease;
            width: 10px;
            z-index: -1;
            top: 0;
        }

        .ux-iws-nb-filter__scroll-outer {
            width: 100%;
            overflow: hidden;
            position: relative;
        }

        .ux-iws-nb-filter__scroll-inner {
            overflow-x: auto;
            overflow-y: hidden;
            white-space: nowrap;
            position: relative;
        }

        form {
            width: var(--ux-iws-nb-filter-form-width, auto);
            display: block;
            flex-wrap: nowrap;
            padding-left: 0;
            padding-right: 0;
            margin-right: 30px;
            margin-left: 30px;
        }

        .ux-label__text {
            position: sticky;
            left: 30px;
        }

        ux-form-group {
            display: inline-block !important;
            flex-grow: 0;
        }

        .ux-form-group__wrapper {
            display: block !important;
            white-space: nowrap;
        }

        .ux-iws-nb-filter__dropdown,
        .ux-dropdown {
            width: auto;
            margin-bottom: 0 !important;
        }

        .ux-dropdown__label ux-icon {
            display: none;
        }

        .ux-dropdown__label {
            white-space: nowrap;
        }

        .ux-dropdown__label > span {
            margin: 0;
        }

        .ux-dropdown--down {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            margin: 0 !important;
            z-index: 1000;
            background: #fff;
            max-width: 100%;
        }

        .ux-dropdown--down ~ .ux-iws-nb-filter-dropdown__close-icon {
            display: block;
            position: fixed;
            top: 11px;
            right: 15px;
            z-index: 1001;
            pointer-events: none;
            font-size: 16px;
            color: #b3d11e;
        }

        .ux-dropdown--down::after {
            content: attr(data-close-label);
            display: inline-block;
            color: #b3d11e;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 13px;
            position: absolute;
            pointer-events: none;
            right: 40px;
            top: 10px;
        }

        .ux-dropdown--down .ux-dropdown__label,
        .ux-dropdown--down .ux-dropdown__menu {
            border: 0;
        }

        .ux-dropdown__dropdown-locator {
            width: 100%;
            height: calc(100vh - 44px);
            transition: none !important;
            z-index: 1000;
            border: 0;
        }

        ux-filterable-list {
            max-height: none !important;
            height: 100%;
            padding-bottom: 38px;
        }

        .ux-dropdown__reset-button {
            transform: translateY(-38px);
        }
    }
}

.ux-iws-nb-filter__scroll-button {
    display: none;
}

.ux-iws-nb-filter-dropdown__close-icon {
    display: none;
}

.ux-iws-nb-filter__headline {
    margin: 0 30px 20px;
    font-size: 1.25rem;

    @media (min-width: 768px) {
        font-size: 1.4375rem;
    }

    @media (min-width: 1024px) {
        font-size: 1.75rem;
    }

    @media (min-width: 1440px) {
        font-size: 1.4375rem;
    }
}

.ux-iws-nb-filter__remove-all {
    display: none;
    margin: 0 15px;
    border-top: 1px solid $color-black-5;
    padding-top: 10px;

    @media screen and (max-width: $ux-iws-nb-filter-mobile-breakpoint) {
        margin-top: 5px;
    }

    @media screen and (min-width: $mobile) {
        margin: 0 30px;
    }

    button {
        appearance: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-flow: row nowrap;
        gap: 8px;
        cursor: pointer;
        background: transparent;
        color: $color-blue-headline;
        border: 0 none transparent;
        border-radius: 0;
        padding: 0;
        @include font(bold);
        font-size: 13px;
        text-transform: uppercase;
    }

    ux-icon {
        font-size: 10px;
    }
}

ux-iws-nb-filter[active-filter] .ux-iws-nb-filter__remove-all {
    display: block;
}

ux-iws-nb-filter ux-filter .ux-filter__remove-all {
    display: none;
}

ux-iws-nb-filter[is-sticky] .ux-iws-nb-filter__container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;

    @media (min-width: 1920px) {
        left: calc((100% - 1920px) / 2);
        right: calc((100% - 1920px) / 2);
    }
}

ux-iws-nb-filter[is-sticky] .ux-iws-nb-filter__placeholder {
    height: var(--filter-height, 0);
}
